import { render } from "./MenuEncuestas.vue?vue&type=template&id=07fa847e"
import script from "./MenuEncuestas.vue?vue&type=script&lang=js"
export * from "./MenuEncuestas.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__